module.exports = "<p>\n  service-management works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/service-management/service-management.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/service-management/service-management.component.html
// module chunks = main